module.exports = __webpack_public_path__ + "img/Back.4b19d45b.jpg";